import React from 'react';
import { Link } from 'react-router-dom';
import { NavBar, Footer } from '../components/Layout';
export default function NotFound() {
  return <div className="min-h-screen flex flex-col bg-white text-apple-gray-800">
    <NavBar />
    <main className="flex-1 max-w-3xl mx-auto px-6 pt-32 pb-20">
      <h1 className="text-4xl font-bold mb-4">Page not found</h1>
      <p className="mb-6">That address doesn’t match a page on this site.</p>
      <Link to="/" className="underline font-semibold">Return to the portfolio</Link>
    </main>
    <Footer />
  </div>;
}
